/**
 * @generated SignedSource<<9c302106e5ed8176042fbe62c9eb8fd9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerHeader_appointment$data = {
  readonly language: Language;
  readonly patientAddress: {
    readonly " $fragmentSpreads": FragmentRefs<"patientAddressTooltip_Address">;
  } | null;
  readonly reason: string;
  readonly " $fragmentType": "appointmentDrawerHeader_appointment";
};
export type appointmentDrawerHeader_appointment$key = {
  readonly " $data"?: appointmentDrawerHeader_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerHeader_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerHeader_appointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "patientAddress",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "patientAddressTooltip_Address"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "1b5c0263910b3bf1ca881a51c64b59f8";

export default node;
